<script setup lang="ts">
import { ref, defineModel, watch } from 'vue'
import $http from 'devcude-common/src/utils/DcHttp'
import $api from '@/config/api'
import qs from 'qs'

const v = defineModel()
const items = ref([])

async function init() {
  let resp = await $http.post($api.shpSupplier.list, qs.stringify({ onPage: false }))
  items.value = resp.data.items
}

init()


</script>

<template>
  <el-select class="!min-w-[160px]" v-model="v">
    <el-option
      v-for="item in items"
      :key="item.id"
      :label="item['name']"
      :value="item['id'] as string"
    />
  </el-select>
</template>

<style scoped>

</style>